import { render, staticRenderFns } from "./ActionBox.vue?vue&type=template&id=4b52c88c&"
import script from "./ActionBox.vue?vue&type=script&lang=js&"
export * from "./ActionBox.vue?vue&type=script&lang=js&"
import style0 from "./ActionBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports